import { Box, Input } from "@mui/material";
import CustomDateTimePicker from "../CustomDateTimePicker";
import { select_options } from "./select_options";
import { BacklogTableCellSelectNew } from "../components/BacklogTableCellSelect";
import { BacklogTableStatusSelectNew } from "../components/BacklogStatusCellSelect";
import { BacklogStatusUpdateSelect } from "../components/BacklogStatusUpdateSelect";
import { useRef, useState } from "react";
import { handle_backlog_AR_Number_Update } from "../../../../../redux/po_backlog/backlog.action";
import { useDispatch, useSelector } from "react-redux";
import { get_po_backlog_state } from "../../../../../redux/po_backlog/backlog.selector";

const status_to_background_color_mapping = {
  "D": "#00b050",
  "N": "#FF0000",
  "U": "#FFC000",
  "warning": "#ffff07",

};

export const render_status_cell = (props) => {
  const { colDef, row } = props;
  const { field } = colDef;
  const status = row[field];
  if (status === "N") {
    return <Box sx={{
      width: "100%",
      height: "100%",
      // padding: "10px",
      // margin: "10px",
      backgroundColor: status_to_background_color_mapping[row[field]],
      display: "flex",
      justifyContent: "start",
      alignItems: "center"
    }}>
      <p className="text-sm p-2">Not Required</p>
    </Box>;
  }
  else {
    return <Box sx={{
      width: "100%",
      // height: "100%",
      // padding: "10px",
      // margin: "10px",
      backgroundColor: status_to_background_color_mapping[row[field]]
    }}>
      <BacklogTableStatusSelectNew excel_row={row} key_name={field} select_options={
        [
          ...select_options.test_status
        ]
      }
        select_status={row[field] || "P"}
      />
    </Box>;
  }
};

export const render_completion_date_picker = (props) => {
  const { colDef, row } = props;
  const { field } = colDef;
  // const status = row[field];
  if (row[field]) return <Box className="px-2">{row[field]}</Box>;
  return <CustomDateTimePicker field={field} row={row} />;
};

export const render_alert_cell = (props) => {
  const { colDef, row } = props;
  const { field } = colDef;
  // const status = row[field];
  const target_alert = 30;
  return <Box
    sx={{
      backgroundColor: row[field] && row[field] > target_alert && "rgb(192, 0, 0)",
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }}
  >
    <p className={`w-full text-sm p-2 text-end ${row[field] && row[field] > target_alert ? "text-white" : "text-black"}`}>
      {row[field]}
    </p>
  </Box>;
};

export const render_remarks_cell = (props) => {
  const { colDef, row } = props;
  const { field } = colDef;
  const status = row[field];
  if (status === "N") {
    return <Box sx={{
      width: "100%",
      height: "100%",
      // padding: "10px",
      // margin: "10px",
      backgroundColor: status_to_background_color_mapping[row[field]],
      display: "flex",
      justifyContent: "start",
      alignItems: "center"
    }}>
      <p className="text-sm p-2">Not Required</p>
    </Box>;
  }
  else {
    return <Box sx={{
      width: "100%",
      // height: "100%",
      // padding: "10px",
      // margin: "10px",
      backgroundColor: status_to_background_color_mapping[row[field]]
    }}>
      <BacklogTableCellSelectNew excel_row={row} key_name={field} select_options={
        [
          ...select_options.reviewer_remark_status
        ]
      }
        select_status={row["remark"] === "UD Approved" ? "Completed" : row[field] || "Pending"}
        is_disabled={!row["remark"] || (row["remark"] && row["remark"] !== "Under Review")}
      />
    </Box>;
  }
};

export const render_backlog_status_remarks_cell = (props) => {
  const { colDef, row } = props;
  const { field } = colDef;
  const status = row[field];
  if (status === "N") {
    return <Box sx={{
      width: "100%",
      height: "100%",
      // padding: "10px",
      // margin: "10px",
      backgroundColor: status_to_background_color_mapping[row[field]],
      display: "flex",
      justifyContent: "start",
      alignItems: "center"
    }}>
      <p className="text-sm p-2">Not Required</p>
    </Box>;
  }
  else {
    return <Box sx={{
      width: "100%",
      // height: "100%",
      // padding: "10px",
      // margin: "10px",
      backgroundColor: status_to_background_color_mapping[row[field]]
    }}>
      <BacklogStatusUpdateSelect excel_row={row} key_name={field} select_options={
        [
          ...select_options.remark_status
        ]
      }
        select_status={row[field] || "Pending"}
      />
    </Box>;
  }
};

export const Render_ar_number_cell = (props) => {
  const backlog = useSelector(get_po_backlog_state);
  const { colDef, row } = props;
  const { field } = colDef;
  // const status = row[field];
  const [ar_number_value, set_ar_number_value] = useState(row?.["AR Number"] || '');
  const updateTimeoutRef = useRef(null);
  const dispatch = useDispatch();
  const handle_change = (e) => {
    const value = e.target.value;
    set_ar_number_value(value);
    if (updateTimeoutRef?.current) {
      clearTimeout(updateTimeoutRef.current);
    }
    updateTimeoutRef.current = setTimeout(async () => {
      dispatch(handle_backlog_AR_Number_Update(backlog, value, row, row.id, field));
    }, 1000);
  };
  return <>
    <Input name={`${row.id}-ar-number-cell`}
      value={ar_number_value}
      onChange={handle_change}
      type="text"
    />
  </>;
};